import {getMethod} from '~/api'

async function get(id, request) {
    return await getMethod(`/api/loyaltyPoints/${id}/`, request)
}

export {get}
